export const isChrome = () => /Google/.test(window.navigator.vendor) && "chrome" in window;

export const isEdge = () => /Edge/.test(navigator.userAgent);

export const isSafari = () => /Safari/.test(navigator.userAgent);

// @ts-ignore
export const isIE11 = () => !!window.MSInputMethodContext && !!document.documentMode;

export const isUnsupportedBrowser = (() => {
  const agent = navigator.userAgent.toLowerCase();
  const msie = /msie/.test(agent);
  const trident = /trident/.test(agent);
  const oldEdge = / edge\//.test(agent);
  const windowsOS = /windows/.test(agent);

  return windowsOS && (trident || msie || oldEdge);
})();

export function getOS() {
  const userAgent = window.navigator.userAgent,
    // @ts-ignore
    platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
    macosPlatforms = ["macOS", "Macintosh", "MacIntel", "MacPPC", "Mac68K"],
    windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
    iosPlatforms = ["iPhone", "iPad", "iPod"];
  const os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    return "Mac OS" as const;
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    return "iOS" as const;
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    return "Windows" as const;
  } else if (/Android/.test(userAgent)) {
    return "Android" as const;
  } else if (/Linux/.test(platform)) {
    return "Linux" as const;
  }

  return os;
}
